import { render } from "./AssetMapComponent.vue?vue&type=template&id=2a050c3c&scoped=true"
import script from "./AssetMapComponent.vue?vue&type=script&lang=js"
export * from "./AssetMapComponent.vue?vue&type=script&lang=js"

import "./AssetMapComponent.vue?vue&type=style&index=0&id=2a050c3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a050c3c"]])

export default __exports__